import { Controller } from "stimulus"

export default class extends Controller {

	static targets = ["qty_type", "qty_available"]

	connect() {
		this.update_qty();
		this.disable_inputs_scrool();
		this.sales_deposit_price();
	}

	sales_deposit_price() {
		const radioButtons = document.querySelectorAll('input[name="product_price_type"]');

		const show = (el) => { if (el) { el.classList.add('sm:grid'); el.classList.remove('hidden'); } };
		const hide = (el, inputId) => {
			if (el) {
				el.classList.remove('sm:grid');
				el.classList.add('hidden');
				const input = document.getElementById(inputId);
				if (input) input.value = null;
			}
		};

		radioButtons.forEach(radio => {
			radio.addEventListener('change', function () {
				if (!this.checked) return;

				document.querySelectorAll('[id^="price-type-desc-"]').forEach((el) => el.classList.add('hidden'));
				document.getElementById('price-type-desc-' + this.value)?.classList.remove('hidden');

				const salePriceContainer = document.getElementById("sale-price-container");
				const depositContainer = document.getElementById("deposit-price-container");
				const unitContainer = document.getElementById("unit-container");

				switch (this.value) {
					case 'sale_price':
						show(salePriceContainer);
						hide(depositContainer, 'product_deposit_price');
						hide(unitContainer, 'product_unit');
						break;
					case 'deposit_price':
						show(depositContainer);
						show(unitContainer);
						hide(salePriceContainer, 'product_sale_price');
						break;
					default: // 'standard'
						hide(salePriceContainer, 'product_sale_price');
						hide(depositContainer, 'product_deposit_price');
						hide(unitContainer, 'product_unit');
						break;
				}
			});
		});
	}

	update_qty(event) {

		// event.preventDefault()

		let input_value = this.qty_typeTarget.value

		if (input_value == "unlimited_quantity") {
			this.qty_availableTarget.classList.add("hidden");
		} else {
			this.qty_availableTarget.classList.remove("hidden");
		}

	}

	disable_inputs_scrool(e) {
		var inputs = document.querySelectorAll('input[type="number"]');
		inputs.forEach(function (element) {
			element.parentElement.addEventListener("wheel", (e) => {
				if (e.target.nodeName == "INPUT")
					e.preventDefault();
			})
		});

	}

}